import {
  Alert,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  ListItemIcon,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import * as React from "react";
import { useSelector } from "react-redux";
import {
  DealerLocation,
  LocationWholegood,
  MatchedProduct,
  PricingType,
  ProductType,
} from "../../../models/features/Integration/DmsSetup";
import { AppState } from "../../../redux/reducer/rootReducer";
import AppGrid from "../../app/AppGrid";
import AppConfirmDialog from "../../app/AppConfirmDialog";
import { useDispatch } from "react-redux";
import {
  addBulkMatchedWholegoods,
  addMatchedProduct,
  removeAllDmsWhoolegoods,
  removeDmsWhoolegoods,
  removeMatchedProduct,
  useSaveSetupMutation,
  useSetIsSyncingV2Mutation,
} from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import { useGetProductByIdMutation } from "../../../redux/reducer/features/Product/productSlice";
import PageLoader from "../../app/PageLoader";
import { Product } from "../../../models/features/Product/Product";
import {
  setSetupOnCreate,
  setSetupId,
  RegenerateTokenApi,
} from "../../../redux/reducer/features/Auth/authSlice";
import ProductDetail from "./Popup/ProductDetail";
import { AppGridId } from "../../../models/app/AppGridModels";
import { GetAppGridColumns } from "../../../services/utilities/utility";
import { Dispatch } from "@reduxjs/toolkit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import MatchManually from "./Popup/MatchManually";
import TruncatedCellWithTooltip from "../../common/TruncatedCellWithTooltip";
import { setPartsPortalEnable } from "../../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";

interface InitializeShopifyProps {
  handleBack: any;
  locations: DealerLocation[];
}

const InitializeShopify: React.FunctionComponent<InitializeShopifyProps> = ({
  handleBack,
  locations,
}) => {
  const gridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Create_Setup_Shopify_Initialization
    )
  );

  const dispatch = useDispatch<Dispatch<any>>();
  const targetWebAccessToken = useSelector(
    (state: AppState) => state.authReducer.targetWebAccessToken
  );
  const { typeToProcess } = useSelector((state: AppState) => state.dmsReducer);
  const { locationIds } = useSelector((state: AppState) => state.dmsReducer);
  const [confirmDialog, setConfirmDialog] = React.useState(false);
  const [setupFailed, setSetupFailed] = React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState<Product>();
  const [selectedItem, setSelectedItem] = React.useState<MatchedProduct>();
  const [stock, setstock] = React.useState<any>([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [Formopen, setFormOpen] = React.useState(false);
  const {
    matchedWholegoods,
    shopifyAccessToken,
    shopifyUrl,
    siteName,
    siteCredentials,
    setupType,
  } = useSelector((state: AppState) => state.dmsReducer);
  const whoolegoods = matchedWholegoods.filter((n) => n.dmsProduct);
  const { dmsDealerId, dealerId, everestDmsDealerId } = useSelector(
    (state: AppState) => state.authReducer
  );
  const { mappedLocations, dmsManufacturers } = useSelector(
    (state: AppState) => state.dmsReducer
  );
  const [priceType, setPriceType] = React.useState(PricingType.Price);
  const [anchorElWG, setAnchorElWG] = React.useState<null | HTMLElement>(null);
  const openWGMenu = Boolean(anchorElWG);
  const [anchorElParts, setAnchorElParts] = React.useState<null | HTMLElement>(
    null
  );
  const openPartsMenu = Boolean(anchorElParts);
  const [popup, setPopup] = React.useState(false);
  const [selectedRowData, setSelectedRowData] =
    React.useState<LocationWholegood[]>();
  const [finishConfirmOpen, setFinishConfirmOpen] = React.useState(false);
  const [saveSetupMutation, saveSetupMutationResult] = useSaveSetupMutation();
  const [setSyncingMutation, setSyncingMutationResult] =
    useSetIsSyncingV2Mutation();
  const onDialogClose = () => {
    setConfirmDialog(false);
  };
  const [productByIdMutation, productByIdMutationResult] =
    useGetProductByIdMutation();
  const onDialogSuccess = () => {
    dispatch(removeMatchedProduct(selectedItem as MatchedProduct));
    dispatch(
      removeDmsWhoolegoods({
        inventoryModelId: selectedItem?.dmsProduct?.inventoryModelId as string,
      })
    );
    setConfirmDialog(false);
  };

  const handleClose = () => {
    setFormOpen(false);
    setFinishConfirmOpen(false);
  };

  const handleWGEditViewClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElWG(event.currentTarget);
  };
  const handleWGEditViewClose = () => {
    setAnchorElWG(null);
  };

  const handlePartsEditViewClose = () => {
    setAnchorElParts(null);
  };

  const handlePopupClose = () => {
    setSelectedRowData([]);
    setPopup(false);
  };

  const Products: MatchedProduct[] = [];

  const handleFinish = async () => {
    try {
      Products.length = 0;
      whoolegoods.forEach((values: any) => Products.push(values));
      const res: any = await saveSetupMutation({
        data: {
          dmsLocations: mappedLocations.filter((loc) =>
            locationIds.some((item) => item === loc.dealerId.toString())
          ),
          matchingProducts: Products,
          storeUrl: shopifyUrl ?? "",
          storeAccessToken: shopifyAccessToken ?? "",
          siteName: siteName ?? "",
          dmsDealerId: dmsDealerId ?? "",
          productTypes: typeToProcess,
          dealerId: dealerId ?? "",
          everestDmsDealerId: everestDmsDealerId ?? "",
          dmsManufacturers: dmsManufacturers,
          setupType: setupType,
          siteCredentials: siteCredentials,
        },
      });

      if (res.data && res.data.status === 0) {
        await setSyncingMutation({
          pricing: priceType,
          dmsSetupId: res.data.entity.id ?? "",
          setSyncing: true,
          productType: ProductType.Wholegoods,
        });
      }

      dispatch(addBulkMatchedWholegoods([]));
      dispatch(removeAllDmsWhoolegoods());
    } catch (error) {
      console.error("Error in handleFinish:", error);
    }
  };

  const handleFinishSync = () => {
    setFinishConfirmOpen(false);
    handleFinish();
  };

  React.useEffect(() => {
    if (productByIdMutationResult.isSuccess) {
      setSelectedProduct(productByIdMutationResult.data.entity);
    }
  }, [productByIdMutationResult]);

  React.useEffect(() => {
    if (
      saveSetupMutationResult.isSuccess &&
      saveSetupMutationResult.data?.status === 0
    ) {
      dispatch(
        RegenerateTokenApi(
          {
            dmsSetupId: saveSetupMutationResult.data?.entity?.id ?? "",
            accessToken: targetWebAccessToken ?? "",
          },
          () => {
            dispatch(
              setSetupId(saveSetupMutationResult.data?.entity?.id ?? "")
            );
            new Promise((resolve) => {
              dispatch(
                setSetupOnCreate({
                  setup: saveSetupMutationResult.data.entity ?? {},
                  callback: resolve,
                })
              );
            });
          }
        )
      );
    } else if (
      saveSetupMutationResult.data?.status === 10 ||
      saveSetupMutationResult.isError
    ) {
      setSetupFailed(true);
    }
  }, [saveSetupMutationResult]);

  React.useEffect(() => {
    if (
      setSyncingMutationResult.isSuccess &&
      setSyncingMutationResult.data?.status === 200
    ) {
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    }
  }, [setSyncingMutationResult]);

  const columns: GridColDef[] = [
    {
      field: "dmsProduct.mfgName",
      headerName: "Manufacturer",
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <TruncatedCellWithTooltip value={params.row.dmsProduct.mfgName} />
        );
      },
    },
    {
      field: "catalogProduct.modelNumber",
      headerName: "Catalog Model Number",
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        const modelNumber = params.row.catalogProduct
          ? params.row.catalogProduct?.modelNumber
          : "N/A";
        return <TruncatedCellWithTooltip value={modelNumber} />;
      },
    },
    {
      field: "dmsProduct.model",
      headerName: "Dms Model",
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <TruncatedCellWithTooltip value={params.row.dmsProduct?.model} />
        );
      },
    },
    {
      field: "catalogProduct.title",
      headerName: "Title",
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        const title = params.row.catalogProduct
          ? params.row.catalogProduct?.title
          : params.row.dmsProduct?.description;
        return <TruncatedCellWithTooltip value={title} />;
      },
    },
    {
      field: "catalogProduct.sku",
      headerName: "Catalog SKU",
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        const sku = params.row.catalogProduct
          ? params.row.catalogProduct?.sku
          : "N/A";
        return <TruncatedCellWithTooltip value={sku} />;
      },
    },
    {
      field: "catalogProduct.category.title",
      headerName: "Category",
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        const categoryTitle = params.row.catalogProduct
          ? params.row.catalogProduct?.category?.title
          : params.row.dmsProduct.productLine;
        return <TruncatedCellWithTooltip value={categoryTitle} />;
      },
    },
    {
      field: "dmsProduct.price",
      headerName: "MSRP ($)",
      align: "right",
      headerAlign: "right",
      type: "number",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.dmsProduct?.price.toFixed(2),
    },
    {
      field: "dmsProduct.count",
      headerName: "Stock",
      align: "right",
      headerAlign: "right",
      type: "number",
      flex: 1,
      filterable: false,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) => {
        if (params.row?.dmsProduct.locationCount) {
          return params.row?.dmsProduct.locationCount?.reduce(
            (partial: number, value: any) => partial + value.count,
            0
          );
        } else {
          return 0;
        }
      },
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      align: "center",
      headerAlign: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.catalogProduct ? (
          <Chip label="Catalog" color="success" size="small" />
        ) : (
          <Chip label="DMS" color="warning" size="small" />
        );
      },
    },
    {
      field: "editView",
      type: "editView",
      headerName: "Edit/View",
      align: "center",
      headerAlign: "center",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Chip
            label="Action"
            color="info"
            clickable
            onClick={(e) => {
              setSelectedItem(params.row);
              handleWGEditViewClick(e);
            }}
          />
        );
      },
    },
  ];

  return (
    <>
      <PageLoader
        isLoading={
          saveSetupMutationResult.isLoading ||
          setSyncingMutationResult.isLoading
        }
      ></PageLoader>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={2}
        p={0.5}
      >
        <Alert severity="info">
          You can sync all wholegoods" to your website or remove items you are
          not ready to send.
        </Alert>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button size="small" variant="outlined" onClick={handleBack}>
            Back
          </Button>
          <Button
            size="small"
            variant="contained"
            disabled={!(whoolegoods.length > 0)}
            onClick={() => setFinishConfirmOpen(true)}
          >
            Finish
          </Button>
        </Box>
      </Box>
      {setupFailed === true ? (
        <Alert
          sx={{ mt: 2 }}
          severity="error"
          onClose={() => {
            setSetupFailed(false);
          }}
        >
          Error occured while saving your setup
        </Alert>
      ) : (
        ""
      )}
      <Box>
        <AppGrid
          gridId={AppGridId.Create_Setup_Shopify_Initialization}
          data={whoolegoods.map((item, index) => ({
            id: index,
            ...item,
          }))}
          columns={GetAppGridColumns(
            columns,
            gridSetting?.columnVisibilityModel
          )}
          isLoading={false}
          selectedRows={selectedRows}
          onSelect={(newSelection: any) => {
            setSelectedRows(newSelection);
          }}
          checkBox={true}
          height="60vh"
        ></AppGrid>
      </Box>
      <AppConfirmDialog
        headerText="Are you sure?"
        bodyText="This product will be removed from matched products."
        onFail={onDialogClose}
        onSuccess={onDialogSuccess}
        handleClose={onDialogClose}
        isOpen={confirmDialog}
      />
      <ProductDetail
        isOpen={Formopen}
        handleClose={handleClose}
        productData={selectedProduct}
        Loading={productByIdMutationResult.isLoading}
        locations={locations}
      />
      <Menu
        anchorEl={anchorElWG}
        id="account-menu"
        open={openWGMenu}
        onClose={handleWGEditViewClose}
        onClick={handleWGEditViewClose}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        {selectedItem?.catalogProduct ? (
          <>
            <MenuItem
              onClick={() => {
                setFormOpen(true);
                productByIdMutation({
                  data: { id: selectedItem?.catalogProduct?.id },
                });
                setstock(selectedItem?.dmsProduct?.locationCount);
              }}
            >
              <ListItemIcon>
                <VisibilityIcon />
              </ListItemIcon>
              View
            </MenuItem>
            <MenuItem
              onClick={() => {
                dispatch(removeMatchedProduct(selectedItem as MatchedProduct));
                dispatch(
                  addMatchedProduct({
                    dmsProduct: selectedItem.dmsProduct as LocationWholegood,
                  })
                );
              }}
            >
              <ListItemIcon>
                <PlaylistRemoveIcon />
              </ListItemIcon>
              Unmatch
            </MenuItem>
          </>
        ) : (
          <MenuItem
            onClick={() => {
              if (selectedItem && selectedItem.dmsProduct) {
                setSelectedRowData([selectedItem.dmsProduct]);
                setPopup(true);
              }
            }}
          >
            <ListItemIcon>
              <AddCircleOutlineRoundedIcon />
            </ListItemIcon>
            Match to
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            setConfirmDialog(true);
          }}
        >
          <ListItemIcon>
            <HighlightOffRoundedIcon />
          </ListItemIcon>
          Remove
        </MenuItem>
      </Menu>
      <MatchManually
        isOpen={popup}
        setPopup={setPopup}
        handleClose={handlePopupClose}
        selectedDmsItems={selectedRowData}
      ></MatchManually>
      <Dialog open={finishConfirmOpen} onClose={handleClose}>
        <DialogContent>
          Are you sure you want to finish? This will save all selected products
          and send them to your website.
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            onClick={() => setFinishConfirmOpen(false)}
          >
            No
          </Button>
          <Button size="small" variant="contained" onClick={handleFinishSync}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Menu
        anchorEl={anchorElParts}
        id="account-menu"
        open={openPartsMenu}
        onClose={handlePartsEditViewClose}
        onClick={handlePartsEditViewClose}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            setConfirmDialog(true);
          }}
        >
          <ListItemIcon>
            <HighlightOffRoundedIcon />
          </ListItemIcon>
          Remove
        </MenuItem>
      </Menu>
    </>
  );
};

export default InitializeShopify;
